import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Icons, MUI, Theme } from '@styles';

// Material-UI Pickers
import { DatePicker, KeyboardDatePicker } from '@material-ui/pickers';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import moment from 'moment';
import MomentUtils from '@date-io/moment';
import 'moment/locale/en-gb';
import 'moment/locale/es-mx';
import 'moment/locale/pt';

// TextField DatePicker
const MuiTextFieldDatePicker = ({ ...props }) => {
  return (
    <MUI.TextField
      {...props}
      InputProps={{ endAdornment: (<Icons.Date />) }}
    />
  );
};

// Formats
// dd/mm/yyyy -> lu/09/2020
// DD/mm/yyyy -> 21/09/2020
// LL -> 21 de septiembre de 2020
// dddd LL -> viernes 21 de septiembre de 2020

class LocalizedUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    return moment(date).format('LL');
  }
}

const MuiDatePicker = (props) => {
  const lsLanguage = JSON.parse(localStorage.getItem('ls.ty-Language'));
  const lang = lsLanguage ? lsLanguage.language : 'es';
  const locale = {
    en: 'en-gb',
    es: 'es-mx',
    pt: 'pt'
  };

  // Set moment locale
  moment.locale(locale[lang]);

  const materialTheme = createMuiTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          height: '70px',
          backgroundColor: Theme.colors.blueDark,
          '& h4': {
            fontFamily: 'Bryant Pro Medium',
            fontSize: Theme.typography.heading4,
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
          },
          '& h6': {
            fontFamily: 'Bryant Pro Medium',
            fontSize: Theme.typography.heading6,
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
          },
        }
      },
      MuiPickersCalendarHeader: {
        iconButton: {
          padding: '8px',
          color: Theme.colors.greyDark,
          '& svg': {
            fontSize: '20px'
          },
        },
        transitionContainer: {
          color: Theme.colors.greyDark,
          '& p': {
            fontFamily: 'Bryant Pro Regular',
            fontSize: Theme.typography.bodyText,
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
          }
        },
        dayLabel: {
          color: Theme.colors.greyMedium,
          fontFamily: 'Bryant Pro Regular',
          fontSize: Theme.typography.smallText,
          fontWeight: 'normal',
          letterSpacing: 'normal',
          whiteSpace: 'normal',
        },
      },
      MuiPickersDay: {
        day: { // Days in calendar
          color: Theme.colors.greyDark,
          '& p': {
            fontFamily: 'Bryant Pro Regular',
            fontSize: Theme.typography.bodyText,
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
          }
        },
        daySelected: { // Calendar circle
          backgroundColor: Theme.colors.blueDark,
          '&:hover': {
            backgroundColor: Theme.colors.blueDark,
          }
        },
        // dayDisabled: {},
        current: { // Current day
          color: Theme.colors.blueDark,
        },
      },
      MuiPickersYear: {
        root: {
          color: Theme.colors.greyDark,
          fontFamily: 'Bryant Pro Regular',
          fontSize: Theme.typography.bodyText,
          fontWeight: 'normal',
          letterSpacing: 'normal',
          whiteSpace: 'normal',

        },
        yearSelected: {
          color: Theme.colors.blueDark,
          fontFamily: 'Bryant Pro Medium',
        }
      },
      MuiPickersMonth: {
        root: {
          color: Theme.colors.greyDark,
          fontFamily: 'Bryant Pro Regular',
          fontSize: Theme.typography.bodyText,
          fontWeight: 'normal',
          letterSpacing: 'normal',
          whiteSpace: 'normal',

        },
        monthSelected: {
          color: Theme.colors.blueDark,
          fontFamily: 'Bryant Pro Medium',
        }
      },
      // MuiDialogActions: {
      //   root: { }
      // },
      // MuiPickersModal: {
      //   dialogAction: {
      //     color: CURRENT_THEME.main,
      //     backgroundColor: CURRENT_THEME
      //   },
      // },
    }
  });

  const {
    allowKeyboard,
    mask,
    ...restProps
  } = props;

  // 
  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={locale[lang]} moment={moment}>
        {!allowKeyboard ? (
          <DatePicker
            {...restProps}
            autoOk
            variant="inline"
            mask={mask ? mask : '__/__/____'}
            leftArrowIcon={<Icons.ArrowLeft />}
            rightArrowIcon={<Icons.ArrowRight />}
            TextFieldComponent={MuiTextFieldDatePicker}
          />
        ) : (
            <KeyboardDatePicker
              {...restProps}
              autoOk
              variant="inline"
              mask={mask ? mask : '__/__/____'}
              leftArrowIcon={<Icons.ArrowLeft />}
              rightArrowIcon={<Icons.ArrowRight />}
              TextFieldComponent={MUI.TextField}
            />
          )}
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

MuiDatePicker.propTypes = {
  // Boolean to change DatePicker to KeyboardDatePicker.
  allowKeyboard: PropTypes.bool,
  // Mask to keyboard.
  mask: PropTypes.string
};

/* KeyboardDatePicker Styles */
export const StyledDatePicker = styled(MuiDatePicker)`
  .MuiIconButton-root {
    padding: 8px;
    right: -8px;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;